import React from 'react';
import { Icon } from './style';

const Pdf = () => (
  <Icon className="icon-pdf">
  </Icon>
);

export default Pdf;
